<template>
  <div class="property-tab">
    <PrioritiesTable :model="model"></PrioritiesTable>
  </div>
</template>

<script setup lang="ts">
import { Choice } from "../mvc/choice";
import { Synchronization } from "../mvc/synchronization";
import { Transition } from "../mvc/transition";
import { computed, onMounted, onBeforeUnmount } from "vue";
import PrioritiesTable from "./PrioritiesTable.vue";

const compProps = defineProps<{
  model: Choice | Synchronization;
}>();

const emit = defineEmits(["notifyChange"]);

const changeNotifier = (model) => {
  emit("notifyChange", model);
};

const transitions = computed((): Array<Transition> => {
  return compProps.model.getOutgoingTransitions();
});

onMounted(() => {
  compProps.model.on("change", changeNotifier, compProps.model);
  transitions.value.forEach((t) => {
    t.on("change", changeNotifier, t);
  });
});

onBeforeUnmount(() => {
  compProps.model.off("change", changeNotifier);
  transitions.value.forEach((t) => {
    t.off("change", changeNotifier);
  });
});
</script>
